"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addLocaleTag = addLocaleTag;
exports.collectResource = collectResource;
exports["default"] = localeText;
exports.formatLocale = formatLocale;
exports.getLocale = getLocale;
exports.getUserLocale = getUserLocale;
exports.init = init;
exports.localeTextFromRes = void 0;
exports.setLocale = setLocale;
exports.setLocaleToCookie = setLocaleToCookie;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _jsCookie = require("js-cookie");
/* eslint-disable no-param-reassign */

var nargs = /\{([0-9a-zA-Z_]+)\}/g;
var defaultLocale = 'en-US';
var curLocale;
var curResource;
function getValue(o, s) {
  s = s.replace(/\[(\w+)\]/g, '.$1');
  s = s.replace(/^\./, '');
  var a = s.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (k in o) {
      o = o[k];
    } else {
      return;
    }
  }
  return o;
}
var formatString = function formatString(string) {
  var args;
  if (arguments.length === 2 && (0, _typeof2["default"])(arguments[1]) === 'object') {
    // eslint-disable-line prefer-rest-params
    args = arguments[1]; // eslint-disable-line prefer-rest-params
  } else {
    args = new Array(arguments.length - 1);
    for (var i = 1; i < arguments.length; ++i) {
      args[i - 1] = arguments[i]; // eslint-disable-line prefer-rest-params
    }
  }
  if (!args || !args.hasOwnProperty) {
    args = {};
  }
  return string.replace(nargs, function (match, i, index) {
    if (string[index - 1] === '{' && string[index + match.length] === '}') {
      return i;
    }
    var result = Object.prototype.hasOwnProperty.call(args, i) ? args[i] : null;
    if (result === null || result === undefined) {
      return '';
    }
    return result;
  });
};
function argumentsToArray(input) {
  var fromIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var args = [];
  for (var i = fromIndex; i < input.length; i++) {
    args.push(input[i]);
  }
  return args;
}
var localeTextFromRes = exports.localeTextFromRes = function localeTextFromRes(key, localeResource) {
  if (key === undefined) {
    return '';
  }
  var localeConfig = localeResource || curResource || {};
  var value;
  if (localeConfig[curLocale]) {
    value = getValue(localeConfig[curLocale], key);
  }
  if (value === undefined && localeConfig[defaultLocale]) {
    value = getValue(localeConfig[defaultLocale], key);
  }
  if (value === undefined) {
    value = key;
    if (process.env.NODE_ENV !== 'production') {
      console.warn("Missing locale key: '".concat(key, "'")); // eslint-disable-line no-console
    }
  }
  if (arguments.length > 2) {
    if ((0, _typeof2["default"])(arguments[2]) === 'object') {
      // eslint-disable-line prefer-rest-params
      value = formatString(value, arguments[2]); // eslint-disable-line prefer-rest-params
    } else {
      value = formatString.apply(void 0, [value].concat((0, _toConsumableArray2["default"])(argumentsToArray(arguments, 2)))); // eslint-disable-line prefer-rest-params
    }
  }
  return value;
};
function localeText(key) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return localeTextFromRes.apply(void 0, [key, null].concat(args));
}
function formatLocale(input) {
  if (input === undefined) {
    return defaultLocale;
  }
  var output = input.replace(/_/g, '-');
  if (output.indexOf('-') > -1) {
    var infos = output.split('-');
    output = "".concat(infos[0].toLowerCase(), "-").concat(infos[1].toUpperCase());
  }
  if (output.toUpperCase() === 'EN') {
    output = 'en-US';
  }
  if (output.toUpperCase() === 'CN' || output.toUpperCase() === 'ZH') {
    output = 'zh-CN';
  }
  return output;
}
function getQueryValue(param) {
  var params = window.location.hash.substr(1);
  var val = params.substr(params.indexOf("".concat(param, "="))).split('&')[0].split('=');
  if (val && val.length > 1) {
    return val[1];
  }
  params = window.location.search.substr(1);
  val = params.substr(params.indexOf("".concat(param, "="))).split('&')[0].split('=');
  if (val && val.length > 1) {
    return val[1];
  }
  return null;
}
function getUserLocale() {
  return formatLocale(getQueryValue('locale') || (0, _jsCookie.get)('locale') || window.localStorage && window.localStorage.getItem('locale') || (navigator ? navigator.language || navigator.browserLanguage || navigator.userLanguage || navigator.systemLanguage || navigator.languages && navigator.languages[0] : defaultLocale));
}
function init(globalResource, customDefaultLocale) {
  if (curLocale) {
    return;
  }
  if (globalResource) {
    curResource = globalResource;
  }
  if (customDefaultLocale) {
    defaultLocale = customDefaultLocale;
  }
  curLocale = getUserLocale();
}
function collectResource(context) {
  if (!context) {
    return {};
  }
  var keys = context.keys();
  var locale = {};
  for (var i = 0; i < keys.length; i++) {
    locale[keys[i].substring(keys[i].lastIndexOf('/') + 1, keys[i].lastIndexOf('.js'))] = context(keys[i])["default"] || context(keys[i]);
  }
  return locale;
}
function addLocaleTag(locale) {
  try {
    var realLocale = locale || getUserLocale();
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('lang', realLocale);
    }
  } catch (e) {
    console.log(e);
  }
}
function getLocale() {
  return curLocale;
}
function setLocale(locale) {
  curLocale = locale;
  addLocaleTag(locale);
}
function setLocaleToCookie(locale, options) {
  setLocale(locale);
  (0, _jsCookie.set)('locale', locale, options || {
    expires: 999
  });
}
/** 在加载localeUtils文件时执行，从而使相应语言的设置生效，比如不同语言下的字体 */
addLocaleTag();